import { getConfig } from '../utils/config';
import { cciBranding } from './cci';
import { getReadyBranding } from './getready';
import { jevBranding } from './jev';
import { midletonBranding } from './midleton';

const { brandingOrganisation } = getConfig();
export const branding = (() => {
  switch (brandingOrganisation) {
    case 'jev':
      return jevBranding;
    case 'midleton':
      return midletonBranding;
    case 'cci':
      return cciBranding;
    case 'getready':
    default:
      return getReadyBranding;
  }
})();
